import React from 'react';
import { Form } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import './GroupSearchSection.scss';

interface GroupSearchSectionProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const GroupSearchSection: React.FC<GroupSearchSectionProps> = ({
  searchTerm,
  setSearchTerm
}) => {
  return (
    <div className="group-search-section-clean">
      <Form.Group>
        <div className="search-input-wrapper-clean">
          <FaSearch className="search-icon-clean" />
          <Form.Control
            type="text"
            placeholder="Buscar grupos por nombre o descripción..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input-clean"
          />
        </div>
      </Form.Group>
    </div>
  );
};

export default GroupSearchSection;
